import React, { useState } from 'react'
import {
  PageWrapper,
  Flex,
  PageFooter,
} from '../../../styling/GlobalStyles'
import { Button } from 'components/ui/Button/Button'
import { Head1 } from 'styling/Typography'
import { tokens } from 'styling/tokens'
import { Pagination } from '../../../components/Pagination/Pagination'
import { useNavigate } from 'react-router-dom'
import {
  clearOperationGroupsList,
  deleteOperationGroup,
  getOperationGroups,
} from '../../../features/operationGroups/operationGroupsSlice'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../../components/NavBar/NavBar'
import { setConfirmModal } from 'features/global/globalSlice'
import { AppDispatch, RootState } from 'store'
import { NoData } from 'components/NoData'
import { getParams, handlePagination } from 'utils/helpers'
import { ModalTypes } from 'types/global.interface'
import { HonestTable, IHonestTableColumn, IHonestTableMenuOption } from 'components/HonestTable/HonestTable'
import useQueryPagination from 'hooks/useQueryPagination'
import { INameId } from 'constants/globalTypes'

export const OperationGroups = () => {
  const { operationGroups, totalPages } = useSelector(
    (store: RootState) => store.operationGroups,
  )
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()
  const [params, setParams] = useState<any>(getParams({ location, ap: { sd: 'a', s: 'name' } }))

  useQueryPagination({ fetchFunctions: [getOperationGroups], cleanUpFunctions: [clearOperationGroupsList], params })


  const handleRemove = (id: number | string) => {
    dispatch(
      setConfirmModal({
        isOpen: true,
        onSave: async () => {
          await dispatch(deleteOperationGroup(id))
        },
        setParams: {
          type: ModalTypes.Delete,
          f: setParams,
          noItems: operationGroups.length < 2,
        },
        word: 'delete operation group',
      }),
    )
  }

  const columns: IHonestTableColumn<any>[] = [
    {
      id: 'name',
      header: 'Name',
      cell: (item) => item.name,
    },
  ]

  const menuOptions: IHonestTableMenuOption<any>[] = [
    { label: 'View', onClick: (item) => navigate('/operations/groups/view/' + item.id) },
    { label: 'Delete', color: tokens.status.danger.fg, onClick: (item) => handleRemove(item.id) },
  ]

  return (
    <>
      <NavBar
        input
        defaultValue={params.q}
        placeholder='Search Operation Groups...'
        setParams={setParams}
        searchFields={['name']}
      />
      <PageWrapper>
        <Flex between center mb='16' >
          <Head1 style={{ fontSize: '1.5rem', lineHeight: 1.3 }} color={tokens.text.primary}>Operation Groups</Head1>
          <Button variant='primary' onClick={() => navigate('/operations/groups/add')}>
            Add Group
          </Button>
        </Flex>
        {operationGroups?.length ? (
          <HonestTable
            columns={columns}
            data={operationGroups as INameId[]}
            keyField='id'
            onClick={(item) => navigate('/operations/groups/view/' + item.id)}
            menuOptions={menuOptions}
          />
        ) : (
          <NoData />
        )}
      </PageWrapper>
      <PageFooter>
        <Pagination
          setPage={(page) => handlePagination(page, setParams)}
          pageCount={Math.ceil(totalPages)}
          forcePage={(params.page ? params.page : 1) - 1}
        />
      </PageFooter>
    </>
  )
}
